"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.NG_MAP_CONFIG_TOKEN = new core_1.OpaqueToken('NG_MAP_CONFIG_TOKEN');
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/map/dist/services/config.js
// module id = 106
// module chunks = 4